/**
 * Tipi TypeScript per il modulo Calendario Risorse.
 */

export type TipoEvento = 'lavoro' | 'ferie' | 'malattia' | 'permesso' | 'manutenzione' | 'trasferta' | 'visita_commerciale'
export type StatoEvento = 'pianificato' | 'confermato' | 'completato'

export interface RisorsaCalendario {
  id: string           // "personale_{uuid}" o "strumento_{uuid}"
  resource_id: string  // UUID puro
  tipo: 'personale' | 'strumento'
  label: string
  ruolo?: string
  tipologia?: string
  gruppo: string       // Per raggruppamento FullCalendar
}

export interface EventoCalendario {
  id: string
  gruppo_id: string
  data: string
  risorsa_tipo: string
  risorsa_id: string
  risorsa_label: string
  commessa_id: string | null
  commessa_label: string | null
  fase_id: string | null
  fase_label: string | null
  cliente_id: string | null
  cliente_label: string | null
  titolo: string
  tipo_evento: TipoEvento
  stato: StatoEvento
  ore: number
  costo_calcolato: number
  note: string | null
  created_by: string | null
  created_at: string | null
}

export interface GruppoEventi {
  gruppo_id: string
  data: string
  titolo: string
  tipo_evento: TipoEvento
  stato: StatoEvento
  commessa_id: string | null
  commessa_label: string | null
  fase_id: string | null
  fase_label: string | null
  cliente_id: string | null
  cliente_label: string | null
  costo_totale: number
  eventi: EventoCalendario[]
}

export interface CommessaAttiva {
  id: string
  numero: string
  titolo: string
  cliente: string
  stato: string
  data_inizio: string | null
  data_consegna: string
}

export interface FaseCalendario {
  id: string
  titolo: string
  ordine: number
  durata_prevista: number
  giorni_effettivi: number
  giorni_calendario: number
  completata: boolean
  tipo: string
  responsabile_nome: string
  partecipanti_ids: string[]
  strumenti_ids: string[]
}

export const TIPO_EVENTO_CONFIG: Record<TipoEvento, { label: string; color: string; bg: string }> = {
  lavoro: { label: 'Lavoro', color: '#4f46e5', bg: '#eef2ff' },
  ferie: { label: 'Ferie', color: '#16a34a', bg: '#f0fdf4' },
  malattia: { label: 'Malattia', color: '#dc2626', bg: '#fef2f2' },
  permesso: { label: 'Permesso', color: '#6b7280', bg: '#f9fafb' },
  manutenzione: { label: 'Manutenzione', color: '#d97706', bg: '#fffbeb' },
  trasferta: { label: 'Trasferta', color: '#0891b2', bg: '#ecfeff' },
  visita_commerciale: { label: 'Visita Commerciale', color: '#7c3aed', bg: '#f5f3ff' },
}

export const STATO_EVENTO_CONFIG: Record<StatoEvento, { label: string }> = {
  pianificato: { label: 'Pianificato' },
  confermato: { label: 'Confermato' },
  completato: { label: 'Completato' },
}
